<template>
    <div class="table-responsive">
        <b-table
            v-if="items.length"
            :fields="fields"
            :items="items"
            responsive="sm"
            hover
        >
            <template #cell(selected)="data">
                <b-form-checkbox
                    class="custom-control-success"
                    v-model="data.item.selected"
                    @change="(v) => onChange(v, data.item)"
                    switch
                    inline
                />
            </template>

            <template #cell(document)="data">
                {{ data.item.file.name }}
            </template>

            <template #cell(legislations)="data">
                <b-badge style="margin-right: 4px;" v-for="legislation in data.item.legislations">{{ legislation.title }}</b-badge>
            </template>

            <template #cell(date_of_declaration)="data">
                {{ data.item.declarationDate }}
            </template>

            <template #cell(validity_of_declaration)="data">
                {{ data.item.declarationValidityDate }}
            </template>

            <template #cell(actions)="data">
                <div class="float-right" style="min-width: 106px;">
                    <Button
                        @click="download(data.item)"
                        class="b-icon btn-sm mr-1"
                    >
                        <b-spinner v-if="data.item.downloading" small />
                        <feather-icon
                            v-else
                            icon="DownloadCloudIcon"
                        />
                    </Button>
                    <Button
                        @click="preview(data.item)"
                        class="b-icon btn-sm"
                    >
                        <feather-icon
                            icon="EyeIcon"
                        />
                    </Button>
                </div>
            </template>
        </b-table>
        <div v-else>
            <b-alert
                class="ml-2 mr-2 mt-1"
                :variant="emptyMessageBg"
                show
            >
                <div class="alert-body">
                    There is no declaration of conformity
                </div>
            </b-alert>
        </div>
    </div>
</template>
<script>
import { BRow, BCol, BFormCheckbox, BTable, BBadge, BAlert, BSpinner } from 'bootstrap-vue'
import Button from "@core/components/common/Button.vue";
export default {
    components: {
        Button, BSpinner, BRow, BCol, BFormCheckbox, BTable, BAlert, BBadge,
    },
    props: {
        documents: {
            required: true
        },
        selectable: {
            default: true
        },
        emptyMessageBg: {
            type: String,
            default: 'secondary'
        }
    },
    data() {
        const fields = [
            { key: 'selected', label: 'Select' },
            { key: 'document', label: 'Document' },
            { key: 'legislations', label: 'Legislations' },
            { key: 'date_of_declaration', label: this.$t('Component(Verification):declaration-date') },
            { key: 'validity_of_declaration', label: this.$t('Component(Verification):validity-of-declaration') },
            { key: 'actions', label: '' },
        ];

        if (!this.selectable) {
            fields.splice(0, 1);
        }

        return {
            fields: fields,
        }
    },
    methods: {
        onChange(value, doc) {
            this.$emit('input', value, doc);
        },
        download(document) {
            document.downloading = true;
            this.$emit('download', document, () => document.downloading = false);
        },
        preview(document) {
            this.$emit('preview', document);
        }
    },
    computed: {
        items() {
            let items = this.documents.filter(d => d.id)
            items.forEach((d) => {
                this.$set(d, 'downloading', false);
                if (!d.hasOwnProperty('selected')) {
                    d.selected = true;
                    this.$emit('input', true, d);
                }
            });

            return items;
        }
    }
}
</script>
